import { defineStore } from 'pinia'
import api from './api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: localStorage.getItem('username') ||null,
    token: localStorage.getItem('token') || null
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token
  },
  
  actions: {
    async login(credentials) {
      try {
        const response = await api.post('/login', credentials)
        this.setUserData(response.data)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    async register(userData) {
      try {
        const response = await api.post('/register', userData)
        this.setUserData(response.data)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    setUserData(data) {
      this.token = data.token
      this.user = {
        id: data.user_id,
        username: data.username
      }
      localStorage.setItem('token', data.token)
      localStorage.setItem('username',data.username)
      api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
    },
    
    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('token')
      localStorage.removeItem('username')    
      delete api.defaults.headers.common['Authorization']
    }
  }
})